/* unplugin-vue-components disabled */import { render } from "./InspectListView.vue?vue&type=template&id=2c082bc7&scoped=true"
import script from "./InspectListView.vue?vue&type=script&lang=js"
export * from "./InspectListView.vue?vue&type=script&lang=js"

import "./InspectListView.vue?vue&type=style&index=0&id=2c082bc7&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c082bc7"]])

export default __exports__